/* clone-lash.js — all behaviour for the Lash Nourishing Serum page. Loaded with `defer` from each section;
   guarded so it only initialises once, and re-binds when a section reloads in the theme editor. */
(function () {
  if (window.cloneLash) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents, currency) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100).replace(/\.00$/, ''); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* ---------- add to cart (theme drawer if available, otherwise /cart) ---------- */
  function add(variantId, qty, btn, msgEl) {
    if (!variantId) return;
    if (btn) btn.setAttribute('aria-busy', 'true');
    /* Themes on Shopify Standard Actions (e.g. Horizon): add through the theme so its cart drawer and icon update */
    var A = window.Shopify && window.Shopify.actions;
    if (A && typeof A.updateCart === 'function') {
      return A.updateCart({ lines: [{ merchandiseId: String(variantId), quantity: qty || 1 }] }, { event: { context: 'product' } })
        .then(function (res) {
          if (btn) btn.removeAttribute('aria-busy');
          if (res && res.userErrors && res.userErrors.length) { if (msgEl) msgEl.textContent = res.userErrors[0].message; return; }
          if (typeof A.openCart === 'function') { try { A.openCart(); } catch (e) {} }
        })
        .catch(function () { window.location.href = root + 'cart'; });
    }
    var drawer = document.querySelector('cart-drawer, cart-notification');
    var sections = drawer && typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    var body = { items: [{ id: Number(variantId), quantity: qty || 1 }] };
    if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (btn) btn.removeAttribute('aria-busy');
        if (!res.ok) { if (msgEl) msgEl.textContent = res.j.description || res.j.message || 'Sorry, that could not be added. Please try again.'; return; }
        if (drawer && typeof drawer.renderContents === 'function' && res.j.sections) {
          var item = res.j.items ? res.j.items[0] : res.j; item.sections = res.j.sections;
          drawer.classList.remove('is-empty'); drawer.renderContents(item);
          var empty = drawer.querySelector('.drawer__inner-empty'); if (empty) empty.remove();
          return;
        }
        if (window.theme && typeof window.theme.openCartDrawer === 'function') { window.theme.openCartDrawer(); return; }
        window.location.href = root + 'cart';
      })
      .catch(function () { window.location.href = root + 'cart'; });
  }

  /* ---------- gallery (scroll-snap track + dots/thumbs/arrows) ---------- */
  function initGallery(g) {
    if (g.dataset.clReady) return; g.dataset.clReady = '1';
    var track = g.querySelector('[data-cl-track]');
    var slides = track ? track.children : [];
    var navs = g.querySelectorAll('[data-cl-go]');
    function current() { return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); }
    function mark(i) { navs.forEach(function (n) { n.setAttribute('aria-current', Number(n.dataset.clGo) === i ? 'true' : 'false'); }); }
    function go(i) { var n = slides.length; i = (i + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); mark(i); }
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { mark(current()); }, 60); }, { passive: true });
    navs.forEach(function (n) { n.addEventListener('click', function () { go(Number(n.dataset.clGo)); }); });
    var p = g.querySelector('[data-cl-prev]'), nx = g.querySelector('[data-cl-next]');
    if (p) p.addEventListener('click', function () { go(current() - 1); });
    if (nx) nx.addEventListener('click', function () { go(current() + 1); });
    g.clGo = go;
  }

  /* ---------- hero product form + variant picker ---------- */
  function initHero(h) {
    if (h.dataset.clReady) return; h.dataset.clReady = '1';
    var jsonEl = h.querySelector('[data-cl-product-json]');
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var currency = h.dataset.currency;
    var form = h.querySelector('form.cl-hero-form');
    var input = h.querySelector('[data-cl-variant-input]');
    var msg = h.querySelector('[data-cl-msg]');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(input.value, 1, form.querySelector('[type=submit]'), msg); });
    var radios = h.querySelectorAll('[data-cl-option]');
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        var opts = []; h.querySelectorAll('[data-cl-options]').forEach(function (fs, i) { var c = fs.querySelector('input:checked'); opts[i] = c && c.value; });
        var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return !opts[i] || o === opts[i]; }); });
        if (!v) return;
        input.value = v.id;
        document.dispatchEvent(new CustomEvent('cl:variant', { detail: { variant: v, currency: currency } }));
        if (v.featured_media) { var g = h.querySelector('[data-cl-gallery]'); var s = h.querySelector('[data-media-id="' + v.featured_media.id + '"]'); if (g && s && g.clGo) g.clGo(Array.prototype.indexOf.call(s.parentNode.children, s)); }
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      });
    });
  }

  /* keep every CTA on the page in sync with the selected variant */
  document.addEventListener('cl:variant', function (e) {
    var v = e.detail.variant, cur = e.detail.currency;
    document.querySelectorAll('[data-cl-atc]').forEach(function (b) {
      b.dataset.variantId = v.id; b.disabled = !v.available;
      var lbl = b.querySelector('[data-cl-label]'); if (lbl) lbl.textContent = v.available ? (b.dataset.label + ' • ' + money(v.price, cur)) : b.dataset.soldout;
    });
    document.querySelectorAll('form.cl-hero-form [type=submit]').forEach(function (b) {
      b.disabled = !v.available; var lbl = b.querySelector('[data-cl-label]'); if (lbl) lbl.textContent = v.available ? (b.dataset.label + ' • ' + money(v.price, cur)) : b.dataset.soldout;
    });
    document.querySelectorAll('[data-cl-price-now]').forEach(function (el) { el.textContent = money(v.price, cur); });
  });

  /* ---------- secondary CTAs ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cl-atc]');
    if (!b) return;
    e.preventDefault();
    var msg = b.parentNode.querySelector('[data-cl-msg]');
    add(b.dataset.variantId, 1, b, msg);
  });

  /* ---------- sticky ATC: shows after the hero CTA scrolls away, hides while another CTA is on screen ---------- */
  function initSticky(bar) {
    if (bar.dataset.clReady) return; bar.dataset.clReady = '1';
    var hero = document.getElementById('cl-hero-atc');
    if (!hero) return;
    var early = bar.hasAttribute('data-cl-early'), ticking = false;
    function inView(el) { var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight; }
    function update() {
      ticking = false;
      var r = hero.getBoundingClientRect();
      var heroOff = early ? !inView(hero) : r.bottom < 0;
      var zoneOn = Array.prototype.some.call(document.querySelectorAll('[data-cl-cta-zone]'), inView);
      var on = heroOff && !zoneOn;
      if (bar.classList.contains('is-visible') !== on) {
        bar.classList.toggle('is-visible', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        bar.querySelectorAll('button').forEach(function (b) { b.tabIndex = on ? 0 : -1; });
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ---------- UGC: tap to play one video at a time, with sound + captions ---------- */
  function initUgc(card) {
    if (card.dataset.clReady) return; card.dataset.clReady = '1';
    var btn = card.querySelector('[data-cl-play]'), video = card.querySelector('video');
    if (!btn || !video) return;
    btn.addEventListener('click', function () {
      document.querySelectorAll('.cl-ugc video').forEach(function (v) { if (v !== video) { v.pause(); v.closest('.cl-ugc').classList.remove('is-playing'); } });
      video.controls = true; video.muted = false; video.preload = 'auto';
      if (video.textTracks && video.textTracks[0]) video.textTracks[0].mode = 'showing';
      card.classList.add('is-playing'); video.play();
    });
    video.addEventListener('ended', function () { card.classList.remove('is-playing'); video.controls = false; });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-cl-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-cl-hero]').forEach(initHero);
    scope.querySelectorAll('.cl-ugc').forEach(initUgc);
    document.querySelectorAll('[data-cl-sticky]').forEach(initSticky);
  }

  window.cloneLash = { add: add, init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
